import React from 'react';
// eslint-disable-next-line import-x/no-extraneous-dependencies
import { useHierarchicalMenu } from 'react-instantsearch';
import { HierarchicalMenuProps } from '@white-nl/instantsearch-components/dist/types/components';
import { ArrowRight } from '../../../ui/icons/sharp/regular';

interface FlatMenuClassNames {
  root: string;
  noRefinementRoot: string;
  list: string;
  childList: string;
  item: string;
  selectedItem: string;
  parentItem: string;
  link: string;
  selectedItemLink: string;
  label: string;
  count: string;
  showMore: string;
  disabledShowMore: string;
}

type HierarchicalListProps = Pick<
  ReturnType<typeof useHierarchicalMenu>,
  'items'
> & {
  className?: string;
  classNames?: Partial<FlatMenuClassNames>;
  createURL: (value: string) => string;
  onNavigate?: ((value: string) => void) | null;
};

function FlatList({
  className = '',
  classNames = {},
  items,
  createURL,
  onNavigate = null,
}: HierarchicalListProps) {
  const listClass = [
    'ais-HierarchicalMenu-list',
    classNames.list,
    className,
  ].filter(Boolean).join(' ');

  const showArrow = classNames.link?.includes('btn-arrow');

  return (
    <div className={classNames.root}>
      <ul className={listClass}>
        {items && items.length > 0 && items.map((item) => {
          const itemClass = [
            'group/link',
            classNames.item,
            item.isRefined ? `active ${classNames.selectedItem}` : '',
          ].filter(Boolean).join(' ');

          return item.value && (
            <li
              key={item.value}
              className={itemClass}
            >
              <a
                className={classNames.link}
                href={createURL(item.value)}
                onClick={(event) => {
                  if (!onNavigate) {
                    return;
                  }
                  event.preventDefault();
                  onNavigate(item.value);
                }}
              >
                {item.label}
                {showArrow && (<ArrowRight iconClass="icon" />)}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default function FlatMenu({
  menu,
  menuSettings,
  additionalData,
}: HierarchicalMenuProps) {
  const {
    classNames,
    hardRefresh,
  } = menuSettings;
  const {
    items,
    refine,
  } = menu;

  const { refinement, categoriesIds } = additionalData;

  return (
    <FlatList
      classNames={classNames}
      items={items}
      createURL={(value: string) => Craft.getUrl(
        Number.isNaN(Number(value)) ? value : (categoriesIds[value] ?? value),
        refinement,
      )}
      onNavigate={hardRefresh ? null : refine}
    />
  );
}
